import { c as _c } from "react/compiler-runtime";
import { usePaypalRestMessages } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks/use-paypal-rest-messages';
export function PaypalRestMessages() {
  const $ = _c(2);
  const {
    data
  } = usePaypalRestMessages();
  let t0;
  if ($[0] !== data) {
    t0 = data ? <ul className="flex list-inside list-disc flex-col gap-3">{data.messages.map(_temp)}</ul> : null;
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(message, index) {
  return <li className="whitespace-normal" key={index}>{message}</li>;
}